export class RelacaoPep {
  public relacaoPep?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
